<template lang="pug">
AppDropdown.pull-right.table-actions-dropdown(
  direction="right"
  label="Actions"
  size="small"
)
  template(v-if="client.permissions.can_update")
    AppDropdownItem(
      v-tooltip="{ ...tooltipOptions, title: 'Edit the client data' }"
      @click="openEditDialog(client.id, 'general')"
    )
      | Edit client
  template(v-else)
    AppDropdownItem(
      v-tooltip="{ ...tooltipOptions, title: 'You are not authorized to edit this client.' }"
      disabled
      @click.stop
    )
      | Edit client

  div
    template(v-if="isActiveClient")
      AppDropdownItem(
        :key="`archive-${client.id}`"
        v-tooltip="{ ...tooltipOptions, title: client.permissions.can_archive ? 'If you are done with this client but want to keep them around' : 'You are not authorized to archive this client.' }"
        :class="{ archive: true }"
        :disabled="!client.permissions.can_archive"
        @click="client.permissions.can_archive ? doArchiveClient(client.id) : null"
      )
        | Archive client

    template(v-else)
      AppDropdownItem(
        :key="`restore-${client.id}`"
        v-tooltip="{ ...tooltipOptions, title: client.permissions.can_restore ? 'If you want to reactivate this client.' : 'You are not authorized to restore this client.' }"
        :class="{ restore: true }"
        :disabled="!client.permissions.can_restore"
        @click="client.permissions.can_restore ? doRestoreClient(client.id) : null"
      )
        | Restore client
</template>

<script>
import { ACTIVE_CLIENT_STATUS } from '~/app_constants';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ClientsTableActions',
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    tooltipOptions: {
      placement: 'left',
    },
  }),
  computed: {
    ...mapState({
      organization: 'organization',
    }),
    isActiveClient() {
      return this.client.status === ACTIVE_CLIENT_STATUS;
    },
  },
  methods: {
    ...mapActions(['archiveClient', 'restoreClient']),
    openEditDialog(clientId, tab) {
      this.$emit('open-edit-dialog', clientId, tab);
    },
    async doArchiveClient(id) {
      if (confirm('Archive this client?')) {
        try {
          await this.archiveClient(id);
          this.$appMessage('Client archived');
        } catch (error) {
          this.showUnexpectedError(error);
        }
      }
    },
    async doRestoreClient(id) {
      if (confirm('Restore this client?')) {
        try {
          await this.restoreClient(id);
          this.$appMessage('Client restored');
        } catch (error) {
          this.showUnexpectedError(error);
        }
      }
    },
    showUnexpectedError({ message }) {
      this.$appMessage(message);
    },
  },
};
</script>
